import ModuleRegistry from 'react-module-container/dist/src/module-registry';
export var NAVIGATE_TO = 'businessManager.navigateTo';
export var NAVIGATE_TO_AND_SHOW_BACK_TOAST = 'businessManager.navigateToAndShowBackToast';
export var PAGE_LINK_COMPONENT = 'businessManager.PageComponentLink';
export var ON_NAVIGATION = 'businessManager.onNavigation';
export var ON_NAVIGATION_COMPLETED = 'businessManager.onNavigationCompleted';
export var ON_CLOSE_IN_EDITOR = 'businessManager.onCloseInEditor';
export var navigateTo = function (navigateToPageConfig) {
    return ModuleRegistry.invoke(NAVIGATE_TO, navigateToPageConfig);
};
export var navigateToAndShowBackToast = function (toConfig, backConfig, toastConfig) {
    return ModuleRegistry.invoke(NAVIGATE_TO_AND_SHOW_BACK_TOAST, toConfig, backConfig, toastConfig);
};
export var getPageComponentLinkComponent = function () {
    return ModuleRegistry.component(PAGE_LINK_COMPONENT);
};
export var onNavigation = function (callback) {
    return ModuleRegistry.addListener(ON_NAVIGATION, callback);
};
export var onNavigationCompleted = function (callback) {
    return ModuleRegistry.addListener(ON_NAVIGATION_COMPLETED, callback);
};
export var onCloseInEditor = function (callback) {
    return ModuleRegistry.addListener(ON_CLOSE_IN_EDITOR, callback);
};
//# sourceMappingURL=navigation.js.map